/* DiFluid OS — Systems.

   Paints the Systems page: the three beats, the four families with
   their rungs, and the one recommendation that changes with the role.

   Words come from OS_CONTENT.SYSTEMS. Prices, availability and the
   sum of the parts come from Shopify, in the JSON block that
   sections/os-systems.liquid writes. Nothing here invents a number.

   The stage shell around it — hero, headline, intro, Learn, Keep
   going — is painted by os.js, exactly as it paints Farm, Roast and
   Brew. This file fills what os.js does not know about, including
   the CoffeeOS band at the foot, which is this page's own. */
(function () {
  "use strict";
  function T(k, en) { var t = window.OS_T; return (t && typeof t[k] === "string" && t[k]) || en; }

  var D = document;
  var C = window.OS_CONTENT;
  if (!C || !C.SYSTEMS) return;
  var S = C.SYSTEMS;

  var root = D.querySelector("[data-os-systems]");
  if (!root) return;

  /* ── Shopify's half ─────────────────────────────────────── */
  var SHOP = (function () {
    var raw = D.querySelector("[data-os-syscatalog]");
    if (!raw) return {};
    try { return JSON.parse(raw.textContent).systems || {}; }
    catch (e) { return {}; }
  })();

  function esc(s) {
    return String(s == null ? "" : s)
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  /* os.js owns the persona. Ask it, and only fall back to reading the
     store directly if this file somehow runs first — the stored value
     is an object, not a bare id, which is the mistake to avoid here. */
  function role() {
    if (window.OS && window.OS.currentId) return window.OS.currentId();
    try {
      var s = JSON.parse(localStorage.getItem("difluid_persona") || "null");
      if (s && s.id) return s.id;
    } catch (e) {}
    return "roaster";
  }

  /* ── The three beats ────────────────────────────────────── */
  function paintHow() {
    var el = root.querySelector("[data-os-how]");
    if (!el || !S.how) return;
    el.innerHTML = S.how.map(function (b, i) {
      return '<div class="os-sysbeat"><span class="os-sysbeat__n">' + (i + 1) +
        '</span><h3>' + esc(b.t) + "</h3><p>" + esc(b.n) + "</p></div>";
    }).join("");
  }

  /* ── What is in a system, drawn ─────────────────────────
     Each part's Shopify handle maps to a device render in OS_GEAR.
     A part with no render (a calibration card, the Bean Sweeper)
     is named in a chip instead. */
  var GEAR_OF = {
    "microbalance-ti": "microbalance-ti",
    "r2-extract": "r2-extract",
    "difluid-r2-pp-brix-refractometer": "r2-pp",
    "difluid-r2-pu-brix-refractometer": "r2-pu",
    "difluid-moment-coffee-flavor-reference-thermometer": "moment",
    "difluid-particle-analysis-coaster": "coaster",
    "omni": "omni",
    "difluid-omix": "omix-plus",
    "difluid-omniflux-live-coffee-roasting-color-tracker": "omniflux",
    "difluid-airwave": "airwave",
    "coffmeter-a1-by-difluid": "coffmeter-a1",
    "coffmeter-m1": "coffmeter-m1",
    "coffmeter-w1": "coffmeter-w1"
  };
  function gearRow(p) {
    var G = window.OS_GEAR || {};
    var hs = p.handles || [], names = p.parts || [];
    var drawn = "", chips = "";
    for (var i = 0; i < names.length; i++) {
      var key = GEAR_OF[hs[i]] || hs[i];
      var src = G[key];
      if (src) {
        drawn += '<span class="os-sys__part"><img src="' + esc(src) + '" alt="" loading="lazy"><span>' + esc(names[i]) + "</span></span>";
      } else {
        chips += '<span class="os-chip">' + esc(names[i]) + "</span>";
      }
    }
    if (!drawn && !chips) return "";
    return '<div class="os-sys__parts">' + drawn + chips + "</div>";
  }

  /* ── One rung ───────────────────────────────────────────── */
  function rung(t) {
    var p = SHOP[t.h];
    if (!p) return "";

    var parts = gearRow(p);

    var price = '<b>' + esc(p.price) + "</b>";
    if (p.save && p.sum) {
      price += '<s>' + esc(p.sum) + "</s>" +
        '<span class="os-sys__save">' + esc(T("systems.saves", "Saves {amount}")).replace("{amount}", function () { return esc(p.save); }) + "</span>";
    }

    var alt = "";
    if (t.alt && SHOP[t.alt]) {
      var a = SHOP[t.alt];
      alt = '<a class="os-sys__alt" href="' + esc(a.url) + '">' +
        esc(t.altLabel || T("systems.also_in", "Also in")) + " \u00b7 " + esc(a.price) +
        (a.avail ? "" : " · " + esc(T("systems.back_soon_lower", "back soon"))) + "</a>";
    }

    return (
      '<article class="os-sys' + (p.avail ? "" : " is-soon") + '">' +
        '<a class="os-sys__shot" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' +
          (p.img ? '<img src="' + esc(p.img) + '" alt="" loading="lazy">' : "") +
        "</a>" +
        '<div class="os-sys__body">' +
          '<h3><a href="' + esc(p.url) + '">' + esc(t.name || p.name) + "</a></h3>" +
          parts +
          '<p class="os-sys__adds">' + esc(t.adds) + "</p>" +
          alt +
        "</div>" +
        '<div class="os-sys__buy">' +
          '<span class="os-sys__price">' + price + "</span>" +
          (p.avail
            ? '<a class="os-sys__go" href="' + esc(p.url) + '">' + esc(T("systems.view", "View")) + "</a>"
            : '<span class="os-sys__soon">' + esc(T("systems.back_soon", "Back soon")) + "</span>") +
        "</div>" +
      "</article>"
    );
  }

  /* ── The families ───────────────────────────────────────── */
  function paintFamilies() {
    var el = root.querySelector("[data-os-fams]");
    if (!el) return;
    var id = role();
    el.innerHTML = S.families.map(function (f) {
      var rungs = f.tiers.map(rung).join("");
      if (!rungs) return "";
      return (
        '<section class="os-sysfam" data-os-fam="' + esc(f.id) + '">' +
          '<div class="os-sysfam__head">' +
            '<p class="os-sectiontitle">' + esc(f.loop) + "</p>" +
            "<h2>" + esc(f.name) + "</h2>" +
            '<p class="os-sysfam__lead">' + esc(f.lead) + "</p>" +
            '<p class="os-sysfam__why" data-os-famwhy>' + esc(C.pick(f.why, id)) + "</p>" +
          "</div>" +
          '<div class="os-sysrungs">' + rungs + "</div>" +
        "</section>"
      );
    }).join("");
  }

  /* ── Where to start, for this role ──────────────────────
     The same card the stage pages lead with: the system's photo,
     its name, the line for this reader, the price. */
  function startHTML(id) {
    var s = S.start[id] || S.start[C.FAMILY[id]] || S.start.roaster;
    if (!s) return "";
    var p = SHOP[s.h];
    if (!p) return "";
    return (
      '<a class="os-rm__sysshot" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' +
        (p.img ? '<img src="' + esc(p.img) + '" alt="" loading="lazy">' : "") +
      "</a>" +
      '<div class="os-rm__syssay">' +
        '<p class="os-eyebrow">' + esc(T("systems.where_to_start", "Where to start")) + "</p>" +
        '<h2><a href="' + esc(p.url) + '">' + esc(p.name) + "</a></h2>" +
        '<p class="os-rm__lead">' + esc(s.n) + "</p>" +
        gearRow(p) +
        '<p class="os-rm__buy">' +
          "<b>" + esc(p.price) + "</b>" +
          (p.save && p.sum ? "<s>" + esc(p.sum) + "</s>" : "") +
          (p.avail
            ? '<a class="os-btn os-btn--primary" href="' + esc(p.url) + '">' + esc(T("systems.see_whats_in_it", "See what is in it")) + "</a>"
            : '<span class="os-rm__soon">' + esc(T("systems.back_soon", "Back soon")) + "</span>") +
        "</p>" +
      "</div>"
    );
  }

  function paintStart(id) {
    var el = root.querySelector("[data-os-start]");
    if (!el) return;
    var html = startHTML(id);
    if (!html) { el.hidden = true; return; }
    el.hidden = false;
    el.innerHTML = html;
  }

  /* ── Role swap. Only the sentences move; the rungs and their
        photographs stay where they are. ───────────────────── */
  function reRole(id) {
    var whys = root.querySelectorAll("[data-os-famwhy]");
    for (var i = 0; i < whys.length; i++) {
      (function (el, f, n) {
        setTimeout(function () {
          el.classList.add("is-out");
          setTimeout(function () {
            var txt = C.pick(f.why, id);
            el.textContent = txt;
            el.hidden = !txt;
            el.classList.remove("is-out");
          }, 260);
        }, n * 85);
      })(whys[i], S.families[i], i);
    }

    var start = root.querySelector("[data-os-start]");
    if (start) {
      start.classList.add("is-out");
      setTimeout(function () {
        paintStart(id);
        start.classList.remove("is-out");
      }, 260);
    }
  }


  /* ── CoffeeOS band ──────────────────────────────────────────
     One coffee followed through four real screens. The steps are
     buttons; the phone shows whichever is active. It advances on its
     own every few seconds while it is on screen, pauses while a
     pointer or focus is inside it, and stops for good once someone
     picks a step. Readers who ask for less motion get no advancing
     and no crossfade. */
  var band = D.querySelector("[data-os-cos]");
  var K = S.cos;
  var cos = { i: 0, n: 0, timer: 0, seen: false, held: false, chosen: false };
  var STEP_MS = 5200;
  var still = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function img(key) { return (window.OS_IMAGES || {})[key] || ""; }

  function cosSet(sel, text) {
    var el = band.querySelector(sel);
    if (el) el.textContent = text;
  }

  function cosShow(i) {
    cos.i = i;
    var btns = band.querySelectorAll("[data-os-cos-step]");
    var shots = band.querySelectorAll("[data-os-cos-shot]");
    for (var k = 0; k < btns.length; k++) {
      var on = k === i;
      btns[k].setAttribute("aria-current", on ? "step" : "false");
      btns[k].parentNode.classList.toggle("is-on", on);
      /* Restart the progress bar by replacing the class. */
      btns[k].parentNode.classList.remove("is-run");
    }
    for (var j = 0; j < shots.length; j++) shots[j].classList.toggle("is-on", j === i);
    if (!cos.chosen && !still && cos.seen && !cos.held && btns[i]) {
      void btns[i].parentNode.offsetWidth;
      btns[i].parentNode.classList.add("is-run");
    }
  }

  function cosStop() { clearTimeout(cos.timer); cos.timer = 0; }

  function cosRun() {
    cosStop();
    var li = band.querySelector(".os-cosband__step.is-on");
    if (li) li.classList.remove("is-run");
    if (cos.chosen || still || !cos.seen || cos.held || cos.n < 2) return;
    if (li) { void li.offsetWidth; li.classList.add("is-run"); }
    cos.timer = setTimeout(function () {
      cosShow((cos.i + 1) % cos.n);
      cosRun();
    }, STEP_MS);
  }

  function paintCos(id) {
    if (!band || !K) return;
    var keys = C.pick(K.flow, id) || [];
    var steps = keys.map(function (k) { return K.steps[k]; }).filter(Boolean);
    if (!steps.length) { band.hidden = true; return; }

    cosSet("[data-os-cos-eyebrow]", K.eyebrow);
    cosSet("[data-os-cos-head]", C.pick(K.head, id));
    cosSet("[data-os-cos-def]", K.def);
    cosSet("[data-os-cos-walk]", C.pick(K.walk, id));
    cosSet("[data-os-cos-cta]", K.cta);

    var facts = band.querySelector("[data-os-cos-facts]");
    if (facts) facts.innerHTML = (K.facts || []).map(function (f) {
      return "<li>" + esc(f) + "</li>";
    }).join("");

    band.querySelector("[data-os-cos-screens]").innerHTML = steps.map(function (s) {
      var u = img(s.img);
      return '<img data-os-cos-shot src="' + esc(u) + '" alt="" loading="lazy" decoding="async">';
    }).join("");

    band.querySelector("[data-os-cos-steps]").innerHTML = steps.map(function (s, i) {
      return (
        '<li class="os-cosband__step">' +
          '<button type="button" data-os-cos-step="' + i + '">' +
            '<span class="os-cosband__n">' + (i + 1) + "</span>" +
            '<span class="os-cosband__body">' +
              '<span class="os-cosband__tag">' + esc(s.tag) + "</span>" +
              '<span class="os-cosband__h">' + esc(s.h) + "</span>" +
              '<span class="os-cosband__line">' + esc(s.n) + "</span>" +
            "</span>" +
          "</button>" +
          '<span class="os-cosband__bar" aria-hidden="true"></span>' +
        "</li>"
      );
    }).join("");

    cos.n = steps.length;
    band.hidden = false;
    cosShow(0);
    cosRun();
  }

  if (band && K) {
    band.addEventListener("click", function (e) {
      var b = e.target.closest && e.target.closest("[data-os-cos-step]");
      if (!b) return;
      cos.chosen = true;
      cosStop();
      cosShow(+b.getAttribute("data-os-cos-step"));
    });
    band.addEventListener("pointerenter", function () { cos.held = true; cosRun(); });
    band.addEventListener("pointerleave", function () { cos.held = false; cosRun(); });
    band.addEventListener("focusin", function () { cos.held = true; cosRun(); });
    band.addEventListener("focusout", function (e) {
      if (!band.contains(e.relatedTarget)) { cos.held = false; cosRun(); }
    });
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(function (ents) {
        cos.seen = ents[0].isIntersecting;
        cosRun();
      }, { threshold: 0.35 }).observe(band);
    } else {
      cos.seen = true;
    }
  }

  /* Width classes on the section, from the width it actually has,
     so the start card lays out the way the stage pages' system card
     does (os.css keys on .os-rm.is-w1/.is-w2). */
  var section = root.closest ? root.closest(".os-room") : null;
  function layout() {
    if (!section) return;
    var w = section.offsetWidth;
    section.classList.toggle("is-w1", w >= 600);
    section.classList.toggle("is-w2", w >= 880);
    section.classList.toggle("is-w3", w >= 1100);
  }
  layout();
  window.addEventListener("resize", layout);
  if ("ResizeObserver" in window && section) new ResizeObserver(layout).observe(section);

  paintHow();
  paintFamilies();
  paintStart(role());
  paintCos(role());

  D.addEventListener("os:role", function (e) {
    var id = (e.detail && e.detail.role) || role();
    reRole(id);
    if (band && K) {
      band.classList.add("is-out");
      setTimeout(function () {
        cos.chosen = false;
        paintCos(id);
        band.classList.remove("is-out");
      }, 260);
    }
  });
})();
